import API from '../../../services/api';

// Office Locations
export const getLocations = async () => API.get("/locations");
export const createLocation = async (data) => API.post("/locations", data);
export const updateLocation = async (id, data) => API.put(`/locations/${id}`, data);
export const deleteLocation = async (id) => API.delete(`/locations/${id}`);

// Reminders
export const getReminders = async () => API.get("/reminders");
export const updateReminder = async (id, data) => API.put(`/reminders/${id}`, data);

// Inventory Low Stock Settings
export const getInventoryItems = async () => API.get("/inventory-settings?settingType=item");
export const updateInventoryItem = async (id, data) =>
  API.patch(`/inventory-settings/${id}`, data);

// Company Info
export const getCompanySettings = async () => API.get("/company-settings");
export const updateCompanySettings = async (data) => API.put("/company-settings", data);
export const uploadCompanyLogo = async (formData) => API.post("/company-settings/logos", formData);

// Workflow Settings
export const getWorkflowSettings = async () => API.get("/workflow-settings");
export const updateWorkflowSettings = async (data) => API.put("/workflow-settings", data);

// Notification Preferences (User Level)
export const getNotificationPreferences = async () => API.get("/notifications/preferences");
export const updateNotificationPreferences = async (data) => API.put("/notifications/preferences", data);




